import { useEffect, useMemo, useState } from 'react';

import { debounce } from 'helpers';
import { observer } from 'mobx-react-lite';
import qs from 'qs';

import { SelectMultiAsync } from '@components/selectmulti';

import { api } from 'api';
import { useStore } from 'models/Provider';

export const toApplicationOption = (application, t) => ({
  label: application.name,
  value: application.id,
  helpText: application.email || t('job.access.limitedaccess.modal.noemail'),
});

export const applicationSearchQuery = (searchStr, jobId, selected) =>
  qs.stringify(
    {
      search_multi_match: searchStr || null,
      job: jobId,
      limit: 10,
      id__is_not: [selected.map((s) => s.value)],
    },
    { addQueryPrefix: true, skipNulls: true, encodeValuesOnly: true, indices: false },
  );

export const ApplicationSearch = observer(({ jobId, label, onSelect, selected = [] }) => {
  const { t } = useStore();
  const [defaultOptions, setDefaultOptions] = useState([]);

  const searchApplications = useMemo(
    () =>
      debounce((searchStr, callback) => {
        let applications = [];
        api.applications.search(applicationSearchQuery(searchStr, jobId, selected)).then((data) => {
          if (data.results.length) {
            data.results.forEach((application) => {
              applications.push(toApplicationOption(application, t));
            });
          }
          callback(applications);
        });
      }, 300),
    [jobId, selected, t],
  );

  useEffect(() => {
    searchApplications('', setDefaultOptions);
  }, [searchApplications]);

  return (
    <SelectMultiAsync
      placeholder={t('job.access.limitedaccess.modal.search')}
      label={label}
      defaultOptions={defaultOptions}
      loadOptions={searchApplications}
      defaultValue={selected}
      onChange={onSelect}
      loadingMessage={() => t('job.access.limitedaccess.modal.searching')}
      noOptions={({ inputValue }) => {
        if (inputValue !== '')
          return t('job.access.limitedaccess.modal.search.nomatch', inputValue);
        return t('job.access.limitedaccess.modal.search.noapplicants');
      }}
    />
  );
});
